import { supabase } from '../lib/supabase';

const toCamelCase = (obj) => {
  if (!obj) return obj;
  return {
    id: obj?.id,
    name: obj?.name,
    position: obj?.position,
    company: obj?.company,
    image: obj?.image,
    imageAlt: obj?.image_alt,
    logo: obj?.logo,
    logoAlt: obj?.logo_alt,
    rating: obj?.rating,
    text: obj?.text,
    services: obj?.services || [],
    featured: obj?.featured,
    createdAt: obj?.created_at,
    updatedAt: obj?.updated_at,
  };
};

const toSnakeCase = (obj) => {
  return {
    name: obj?.name,
    position: obj?.position,
    company: obj?.company,
    image: obj?.image,
    image_alt: obj?.imageAlt,
    logo: obj?.logo,
    logo_alt: obj?.logoAlt,
    rating: obj?.rating,
    text: obj?.text,
    services: obj?.services,
    featured: obj?.featured,
  };
};

export const testimonialService = {
  async getAll() {
    const { data, error } = await supabase?.from('testimonials')?.select('*')?.order('created_at', { ascending: false });

    if (error) throw error;
    return data?.map(toCamelCase) || [];
  },

  async create(testimonial) {
    const { data, error } = await supabase?.from('testimonials')?.insert(toSnakeCase(testimonial))?.select()?.single();

    if (error) throw error;
    return toCamelCase(data);
  },

  async update(id, testimonial) {
    const { data, error } = await supabase?.from('testimonials')?.update(toSnakeCase(testimonial))?.eq('id', id)?.select()?.single();

    if (error) throw error;
    return toCamelCase(data);
  },

  async delete(id) {
    const { error } = await supabase?.from('testimonials')?.delete()?.eq('id', id);

    if (error) throw error;
  },

  subscribeToChanges(callback) {
    const channel = supabase
      ?.channel('testimonials-changes')
      ?.on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'testimonials' },
        (payload) => {
          const transformedPayload = {
            eventType: payload?.eventType,
            new: payload?.new ? toCamelCase(payload?.new) : null,
            old: payload?.old ? toCamelCase(payload?.old) : null,
          };
          callback(transformedPayload);
        }
      )
      ?.subscribe();

    return () => {
      supabase?.removeChannel(channel);
    };
  },
};
